var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-description"},[(_vm.formDescription.heading)?_c('div',{staticClass:"heading",domProps:{"innerHTML":_vm._s(_vm.formDescription.heading)}}):_vm._e(),_vm._v(" "),(_vm.formDescription.subHeading)?_c('div',{staticClass:"sub-heading",domProps:{"innerHTML":_vm._s(_vm.formDescription.subHeading)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }